"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoogleCampaign = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const typeorm_1 = require("typeorm");
const uuid_1 = require("uuid");
const AdServingOptimizationStatus_1 = require("../domain/AdServingOptimizationStatus");
const GeoTargetTypeSetting_1 = require("../domain/GeoTargetTypeSetting");
const BiddingStrategyConfiguration_1 = require("./BiddingStrategyConfiguration");
const GoogleCampaignBudget_1 = require("./GoogleCampaignBudget");
const NetworkSetting_1 = require("./NetworkSetting");
let GoogleCampaign = class GoogleCampaign {
    _id = (0, uuid_1.v4)();
    campaignId;
    routeId;
    name;
    status = "PAUSED";
    startDate;
    endDate = "2037-12-30";
    budget;
    adGroups = [];
    keywords;
    adServingOptimizationStatus;
    settings = new Array(new GeoTargetTypeSetting_1.GeoTargetTypeSetting());
    networkSetting;
    biddingStrategyConfiguration;
    trackingUrlTemplate = "";
    urlCustomParameters = [];
    isOtherDirection;
    targetingLocations = [];
    adwordsCustomerId;
};
exports.GoogleCampaign = GoogleCampaign;
__decorate([
    (0, typeorm_1.ObjectIdColumn)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_transformer_1.Expose)()
    // internal database id
    ,
    __metadata("design:type", String)
], GoogleCampaign.prototype, "_id", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)()
    // campaign id from google
    ,
    __metadata("design:type", String)
], GoogleCampaign.prototype, "campaignId", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], GoogleCampaign.prototype, "routeId", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], GoogleCampaign.prototype, "name", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], GoogleCampaign.prototype, "status", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)()
    // format YYYY-MM-DD
    ,
    __metadata("design:type", String)
], GoogleCampaign.prototype, "startDate", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)()
    // format YYYY-MM-DD.  Defaults is 2037-12-30, which means the campaign will run indefinitely
    ,
    __metadata("design:type", String)
], GoogleCampaign.prototype, "endDate", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", GoogleCampaignBudget_1.GoogleCampaignBudget)
], GoogleCampaign.prototype, "budget", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], GoogleCampaign.prototype, "adGroups", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GoogleCampaign.prototype, "keywords", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], GoogleCampaign.prototype, "adServingOptimizationStatus", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], GoogleCampaign.prototype, "settings", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", NetworkSetting_1.NetworkSetting)
], GoogleCampaign.prototype, "networkSetting", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", BiddingStrategyConfiguration_1.BiddingStrategyConfiguration)
], GoogleCampaign.prototype, "biddingStrategyConfiguration", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], GoogleCampaign.prototype, "trackingUrlTemplate", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], GoogleCampaign.prototype, "urlCustomParameters", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], GoogleCampaign.prototype, "isOtherDirection", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], GoogleCampaign.prototype, "targetingLocations", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], GoogleCampaign.prototype, "adwordsCustomerId", void 0);
exports.GoogleCampaign = GoogleCampaign = __decorate([
    (0, typeorm_1.Entity)("googleCampaigns")
], GoogleCampaign);
//# sourceMappingURL=GoogleCampaign.js.map